<template>
  <span class="leo-form-label-with-tip">
    <span class="leo-form-label-text">{{ label }}</span>
    <el-tooltip placement="top" effect="dark" popper-class="leo-knowledge-tip-popper">
      <div slot="content" class="leo-tip-rich">{{ tip }}</div>
      <i class="el-icon-question leo-field-tip-icon"></i>
    </el-tooltip>
  </span>
</template>

<script>
export default {
  name: 'LeoFormLabelTip',
  props: {
    label: { type: String, required: true },
    tip: { type: String, required: true }
  }
}
</script>

<style scoped>
.leo-field-tip-icon {
  margin-left: 6px;
  color: #909399;
  cursor: help;
  font-size: 14px;
  vertical-align: middle;
}
.leo-field-tip-icon:hover {
  color: #409eff;
}
</style>

<style>
.leo-knowledge-tip-popper {
  max-width: 440px !important;
}
.leo-knowledge-tip-popper .leo-tip-rich {
  line-height: 1.55;
  word-break: break-word;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/LeoKnowledge/LeoFormLabelTip.vue